<script>
import _ from 'lodash'
import moment from 'moment'
import TimeUtils from '@/utils/time'
import FollowupService from '@/request/followup/followup'
export default {
  name: 'FollowupEdit',
  components: {},
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    common: {
      type: Object,
      default () {
        return {}
      }
    },
    records: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data () {
    return {
      commonback: {},
      followup: _.defaultsDeep(_.cloneDeep(this.data), this.defaultOptions),
      back: _.defaultsDeep(_.cloneDeep(this.data), this.defaultOptions),
      count: 1,
      benchmark: 'days',
      time: 3600000,
      errmsg: null,
      saving: false
    }
  },
  computed: {
    defaultOptions () {
      return {
        num: 0,
        time: null,
        label: null,
        inquiry: null,
        auto: 0
      }
    }
  },
  created: function () {
    this.init(false)
  },
  watch: {
    data() {
      this.init(false)
    },
    common: {
      handler: function () {
        if (_.isEmpty(this.commonback) || _.isEqual(this.common, this.commonback)) {
          return
        }
        this.init(true)
      },
      deep: true
    },
    count () {
      this.durationToTime()
    },
    benchmark () {
      this.durationToTime()
    },
    time (val) {
      this.time = moment(val).valueOf() - moment(val).startOf('day').valueOf() - (8 * 60 * 60 * 1000)
      this.durationToTime()
    }
  },
  methods: {
    init (noInit) {
      const _followup = _.clone(this.followup)
      this.commonback = _.cloneDeep(this.common)
      // this.back = _.defaultsDeep(_.cloneDeep(this.data), this.defaultOptions)
      this.followup = _.assign(_.defaultsDeep(_.cloneDeep(this.data), this.defaultOptions), this.common)
      if (noInit) {
        this.durationToTime()
        this.followup.label = _followup.label
        this.followup.inquiry = _followup.inquiry
      }
      let start = this.followup.startTime || moment().startOf('day').valueOf()
      let end = this.followup.time || moment(start).add(1, 'd').startOf('day').add(9, 'h').valueOf()
      let duration = TimeUtils.timeToDuration(start, end)
      let _duration = moment(duration).startOf('day')
      this.time = duration - _duration.valueOf()
      let zero = moment(0).startOf('day')
      let years = _duration.clone().diff(zero, 'years', true)
      let months = _duration.clone().diff(zero, 'months', true)
      let weeks = _duration.clone().diff(zero, 'weeks', true)
      let days = _duration.clone().diff(zero, 'days', true)
      let mills = _duration.clone().diff(zero)
      if (_.isInteger(years) && years) {
        this.count = years
        this.benchmark = 'years'
      } else if (_.isInteger(months) && months) {
        this.count = months
        this.benchmark = 'months'
      } else if (_.isInteger(weeks) && weeks) {
        this.count = weeks
        this.benchmark = 'weeks'
      } else if (_.isInteger(days) && days) {
        this.count = days
        this.benchmark = 'days'
      } else {
        this.count = 0
        this.benchmark = 'days'
        this.time += mills
      }
      this.time -= 8 * 60 * 60 * 1000
    },
    durationToTime () {
      let zero = moment(0).startOf('day')
      let duration = zero.clone().add(this.count, this.benchmark).startOf('day') + this.time + (8 * 60 * 60 * 1000)
      let start = this.common.startTime || moment().startOf('day').valueOf()
      this.followup.time = TimeUtils.durationToTime(start, duration)
    },
    queryLabels (queryString, callback) {
      let results = [{
        value: '复诊',
        name: '复诊',
        inquiry: '请于近日来院复诊、复查'
      }, {
        value: '用药',
        name: '用药',
        inquiry: '请遵医嘱按时按量服药'
      }, {
        value: '换药',
        name: '换药',
        inquiry: '请于近日返院换药'
      }, {
        value: '手术',
        name: '手术',
        inquiry: '请于近日至院手术'
      }]
      callback(results)
    },
    handleSelectLabel (item) {
      if (item && item.inquiry) {
        this.$set(this.followup, 'inquiry', item.inquiry)
      }
    },
    removeFollowup (param) {
      if (!this.data || !this.data.id) {
        this.$emit('remove', this.data, param)
        return
      }
      this.$confirm('确认删除一项随访计划吗?', '提示', {type: 'warning'}).then(() => {
        FollowupService.delete({
          id: this.data.id
        }).then(() => {
          this.$emit('remove', this.data, param)
        }).catch(error => {
          this.$message.error(error || '删除随访计划失败')
        })
      }, () => {
        this.$message({
          message: '取消操作!',
          type: 'info'
        })
      })
    },
    save (param) {
      if (_.isEqual(this.followup, this.back)) {
        this.$emit('saveDone', null, this.data, param)
        return
      }
      const recordFollowupsList = []
      this.saving = true
      const records = _.clone(this.records)
      _.forEach(records, val => {
        let _followup = _.clone(this.followup)
        _followup.id = this.data.id || null
        _followup.oid = val.oid
        _followup.patId = val.pat
        _followup.historySn = val.historySn
        _followup.name = val.patName
        _followup.sex = val.sex
        _followup.age = val.age
        _followup.mobile = _followup.mobile || val.mobile // 患者手机号
        _followup.address = val.address // 患者住址
        _followup.operationTime = val.arrangedStartTime // 手术时间
        _followup.diseases = val.diagnoseNames // 病历诊断
        _followup.treatment = val.operatingNames // 病历术式
        _followup.diseaseRecordId = val.id // 病历id
        _followup.hospitalized = val.hospitalized
        recordFollowupsList.push(_followup)
      })
      _.forEach(recordFollowupsList, val => {
        FollowupService.save(val).then(res => {
          this.$emit('saveDone', res.result || {}, this.data, param)
        }).catch(error => {
          this.errmsg = error || '保存失败'
        }).finally(() => {
          this.saving = false
        })
      })
    }
  }
}
</script>

<template>
  <el-form :model="followup" :disabled="saving" size="mini" class="box" label-position="right" label-width="100px">
    <span class="followup-num">{{followup.num}}</span>
    <span class="followup-tools">
      <i v-if="!followup.state" class="el-icon-delete tool-item" style="color: #F56C6C;" @click="removeFollowup"></i>
    </span>
    <div v-if="errmsg" class="error-message">{{errmsg}}</div>
    <el-form-item label="时间">
      <el-col :span="10">
        <el-input-number v-model="count" controls-position="right" :min="1" style="width: 100%;"></el-input-number>
      </el-col>
      <el-col :span="4">
        <el-select v-model="benchmark" placeholder="请选择" style="width: 100%;">
          <el-option label="日后" value="days"></el-option>
          <el-option label="周后" value="weeks"></el-option>
          <el-option label="月后" value="months"></el-option>
          <el-option label="年后" value="years"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10">
        <el-time-picker v-model="time" format="HH:mm:ss" value-format="timestamp" :clearable="false" placeholder="时间点" style="width: 100%;"></el-time-picker>
      </el-col>
    </el-form-item>
    <el-form-item label="事项" prop="label">
      <el-autocomplete
        v-model="followup.label"
        placeholder="请输入事项"
        :fetch-suggestions="queryLabels"
        @select="handleSelectLabel"
        style="width: 100%;"
      ></el-autocomplete>
    </el-form-item>
    <el-form-item label="内容">
      <el-input v-model="followup.inquiry" type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入随访内容"></el-input>
    </el-form-item>
    <!--<el-form-item label="自动随访">
      <el-radio-group v-model="followup.auto">
        <el-radio :label="parseInt(0)" border>否</el-radio>
        <el-radio :label="parseInt(1)" border>是</el-radio>
      </el-radio-group>
    </el-form-item>-->
  </el-form>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  padding: 20px 20px 0 20px;
  background: #F2F6FC;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  margin-bottom: 10px;
  position: relative;
}
.followup-num {
  width: 32px;
  height: 32px;
  display: block;
  border-radius: 50%;
  background: #409EFF;
  text-align: center;
  line-height: 32px;
  font-size: 32px;
  color: #F2F6FC;
  overflow: hidden;
  position: absolute;
  top: 20px;
  left: 20px;
}
.followup-tools {
  width: 32px;
  display: block;
  text-align: center;
  line-height: 32px;
  font-size: 18px;
  position: absolute;
  top: 60px;
  left: 20px;
}
.followup-tools .tool-item {
  cursor: pointer;
}
.error-message {
  text-align: center;
  color: #F56C6C;
}
</style>
